import { ReportTableColumn, ReportTableDropdown } from "../../models/reports.model";
import { WarehouseRentalMenuEnum } from "./report-warehouse-rental-v2.enum";
import { DataType } from "src/app/common/models/enums/common.enum";

export class WarehouseRentalReportConstant {

    static overViewMenu = [
        {
            label: 'reports.overview',
            name: WarehouseRentalMenuEnum.overview,
        },
        {
            label: 'reports.rentUnitSizeWise',
            name: WarehouseRentalMenuEnum.retailUnitSize,
        },
        {
            label: 'reports.projectsProperties',
            name: WarehouseRentalMenuEnum.property,
        }
    ]

    static retailUnitsizeExpandColumns: any[] = [
        { field: 'neigh_name' },
        { field: 'dry_warehouse_range' },
        { field: 'cold_storage_range' },
        { field: 'frozen_warehouse_range' },
        { field: 'open_yard_range' }
    ];
    static retailUnitsizeExpandAverageColumns: any[] = [{ field: 'neigh_name', convertNumber: false }, { field: 'dry_warehouse_avg', convertNumber: true }, { field: 'cold_storage_avg', convertNumber: true }, { field: 'frozen_warehouse_avg', convertNumber: true }, { field: 'open_yard_avg', convertNumber: true }];



    static retailUnitsizeAverageColumns: ReportTableColumn[] = [
        {
            header: 'unit_size',
            columnName: 'reports.unit_size',
            field: 'unit_size',
            isSortable: false,
            border: false,
            symbol: DataType.squareMeter,
            isContainsHTML: false,
            convertNumber: false,
        },
        {
            header: 'dry_warehouse_avg',
            columnName: 'reports.dry_warehouse',
            field: 'dry_warehouse_avg',
            symbol: DataType.currencyWithSquareMeter,
            isSortable: false,
            border: false,
            isContainsHTML: false,
            convertNumber: true,
            toolTipField: 'dry_warehouse_range',
        },
        {
            header: 'cold_storage_avg',
            columnName: 'reports.cold_storage',
            field: 'cold_storage_avg',
            symbol: DataType.currencyWithSquareMeter,
            border: false,
            isSortable: false,
            isContainsHTML: false,
            convertNumber: true,
            toolTipField: 'cold_storage_range',
        },
        {
            header: 'frozen_warehouse_avg',
            columnName: 'reports.frozen_warehouse',
            field: 'frozen_warehouse_avg',
            symbol: DataType.currencyWithSquareMeter,
            border: false,
            isSortable: false,
            isContainsHTML: false,
            convertNumber: true,
            toolTipField: 'frozen_warehouse_range',
        },
        {
            header: 'ambient_avg',
            columnName: 'reports.ambient',
            field: 'ambient_avg',
            symbol: DataType.currencyWithSquareMeter,
            border: false,
            isSortable: false,
            isContainsHTML: false,
            convertNumber: true,
            toolTipField: 'ambient_range',
        }

    ]

    static warehouseUnitsizeColumns: ReportTableColumn[] = [
        {
            header: 'unit_size',
            columnName: 'reports.unit_size',
            field: 'unit_size',
            isSortable: false,
            border: false,
            symbol: DataType.squareMeter,
            isContainsHTML: false,
            convertNumber: false,
        },
        {
            header: 'dry_warehouse_range',
            columnName: 'reports.dry_warehouse',
            field: 'dry_warehouse_range',
            symbol: DataType.currencyWithSquareMeter,
            isSortable: false,
            border: false,
            isContainsHTML: false,
            convertNumber: false,
            toolTipField: 'dry_warehouse_avg',
        },

        {
            header: 'cold_storage_range',
            columnName: 'reports.cold_storage',
            field: 'cold_storage_range',
            symbol: DataType.currencyWithSquareMeter,
            isSortable: false,
            border: false,
            isContainsHTML: false,
            convertNumber: false,
            toolTipField: 'cold_storage_avg',
        },
        {
            header: 'frozen_warehouse_range',
            columnName: 'reports.frozen_warehouse',
            field: 'frozen_warehouse_range',
            symbol: DataType.currencyWithSquareMeter,
            border: false,
            isSortable: false,
            isContainsHTML: false,
            convertNumber: false,
            toolTipField: 'frozen_warehouse_avg',
        },
        {
            header: 'ambient_range',
            columnName: 'reports.ambient',
            field: 'ambient_range',
            symbol: DataType.currencyWithSquareMeter,
            border: false,
            isSortable: false,
            isContainsHTML: false,
            convertNumber: false,
            toolTipField: 'ambient_avg'
        }

    ]

    static warehousePropertiesColumns: ReportTableColumn[] = [
        {
            header: 'property_name',
            columnName: 'reports.property_name',
            field: 'property_name',
            isSortable: false,
            border: false,
            isContainsHTML: false,
            convertNumber: false,
            showOnMap: true,
            isAnchor: true
        },
        {
            header: 'no_of_warehouse',
            columnName: 'reports.no_of_Warehouse',
            field: 'no_of_warehouse',
            border: false,
            isSortable: false,
            isContainsHTML: false,
            convertNumber: true
        },
        {
            header: 'grade',
            columnName: 'reports.grade',
            field: 'grade',
            isSortable: false,
            border: false,
            isContainsHTML: false,
            convertNumber: false,
        },
        {
            header: 'land_area',
            columnName: 'reports.land_area',
            field: 'land_area',
            border: false,
            isSortable: false,
            symbol: DataType.squareMeter,
            isContainsHTML: false,
            convertNumber: true
        },
        {
            header: 'gla',
            columnName: 'reports.gross_leasable_area',
            field: 'gla',
            border: false,
            isSortable: false,
            symbol: DataType.squareMeter,
            isContainsHTML: false,
            convertNumber: true
        },
        {
            header: 'lease_rate_range',
            columnName: 'reports.lease_rate',
            field: 'lease_rate_range',
            border: false,
            isSortable: false,
            isContainsHTML: false,
            convertNumber: false,
            symbol: DataType.currencyWithSquareMeter,
        },
        {
            header: 'neigh_name',
            columnName: 'reports.NEIGHBORHOODS',
            field: 'neigh_name',
            isSortable: false,
            border: false,
            isContainsHTML: false,
            convertNumber: false
        }
    ]
    static warehousePropertiesAverageColumns: ReportTableColumn[] = [
        {
            header: 'project_name',
            columnName: 'reports.projectNameUnitType',
            field: 'project_name',
            isSortable: false,
            border: false,
            isContainsHTML: false,
            convertNumber: false,
            showOnMap: true,
            isAnchor: true
        },
        {
            header: 'no_of_warehouse',
            columnName: 'reports.no_of_Warehouse',
            field: 'no_of_warehouse',
            border: false,
            isSortable: false,
            isContainsHTML: false,
            convertNumber: true
        },
        {
            header: 'grade',
            columnName: 'reports.grade',
            field: 'grade',
            isSortable: false,
            border: false,
            isContainsHTML: false,
            convertNumber: false,
        },
        {
            header: 'land_area',
            columnName: 'reports.land_area',
            field: 'land_area',
            border: false,
            isSortable: false,
            symbol: DataType.squareMeter,
            isContainsHTML: false,
            convertNumber: true
        },
        {
            header: 'gla',
            columnName: 'reports.gross_leasable_area',
            field: 'gla',
            border: false,
            isSortable: false,
            symbol: DataType.squareMeter,
            isContainsHTML: false,
            convertNumber: true
        },
        {
            header: 'lease_rate_avg',
            columnName: 'reports.lease_rate',
            field: 'lease_rate_avg',
            border: false,
            isSortable: false,
            isContainsHTML: false,
            convertNumber: true,
            symbol: DataType.currencyWithSquareMeter,
        },
        {
            header: 'neigh_name',
            columnName: 'reports.NEIGHBORHOODS',
            field: 'neigh_name',
            isSortable: false,
            border: false,
            isContainsHTML: false,
            convertNumber: false
        }
    ]


    static unitSizeDropdown: ReportTableDropdown = {
        label: 'reports.show_price_in',
        data: [{
            value: 'Range',
            id: 'Range',
        }, {
            value: 'Average',
            id: 'Average',
        }],
        default: 'Range',
        maxSelect: 1,
        reportType: false
    }
    static propertiesDropdown: ReportTableDropdown = {
        label: 'reports.show_price_in',
        data: [{
            value: 'Range',
            id: 'Range',
        }, {
            value: 'Average',
            id: 'Average',
        }],
        default: 'Range',
        maxSelect: 1,
        reportType: false
    }

}
